/** OneGrid 패키지 버전 (package.json 에서 자동 생성 — scripts/write-version.mjs) */
export const VERSION = '1.2.0';
